import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { gameName, userLevelArray } from "../Globals/globalMetaData";
import { hasAccess } from "../Globals/globalFunctions";
import { SvgIcon } from "../Components/SvgIcons";

function HeaderAndSidenav() {
	const account = JSON.parse(localStorage.getItem("account"));
	const navigate = useNavigate();

	const handleLogout = () => {
		localStorage.clear();
		navigate("/login");
	};
	return (
		<>
			<nav class="navbar navbar-custom p-0" role="navigation">
				<div class="container-fluid">
					<div class="navbar-header">
						<a class="navbar-brand">
							<span>
								<img src="/assets/images/logo.png" width="94" height="70" style={{ objectFit: "contain" }} /> {gameName}{" "}
							</span>
							{userLevelArray?.find((item) => item?.level == account?.level)?.name}
						</a>
						<div className="d-flex align-items-center">
							<div className="balanceWrap">{account?.user_balance}</div>
							<div className="buttonGroup">
								{hasAccess(account, 1) && (
									<button className="clearButton2 mx-2" onClick={() => navigate("playout-mode")}>
										<SvgIcon name="gear" />
									</button>
								)}
								<button className="clearButton2 bg-transparent" onClick={handleLogout}>
									<SvgIcon name="power" style={{ color: "#dc3545" }} />
								</button>
							</div>
						</div>
					</div>
				</div>
			</nav>
			<div className="layout">
				{/* {account && ( */}
				<aside className="col-sm-3 col-lg-2 sidebar in">
					<div class="profile-sidebar">
						<div class="profile-userpic">
							<img src="/assets/images/usericon.png" />
						</div>
						<div class="profile-usertitle">
							<div class="profile-usertitle-name">
								<a>{account?.username}</a>
							</div>
							<div class="profile-usertitle-status">
								<span class="indicator" style={{ background: "#8ad919" }}></span>
								Online
							</div>
						</div>
					</div>
					<ul class="nav menu">
						<li>
							<NavLink to="/">
								<SvgIcon name="dashboard" />
								<span>Dashboard</span>
							</NavLink>
						</li>

						{hasAccess(account, 0) && (
							<>
								<li>
									<NavLink to="/game-manager">
										<img src="/assets/images/result-history.png" width="30" height="30" /> Game Manager
									</NavLink>
								</li>
								<li>
									<NavLink to="/all-super-stokez">
										<img src="/assets/images/stokez.png" width="30" height="30" /> View Super Stokist
									</NavLink>
								</li>
							</>
						)}
						{/* <li>
              <NavLink to="/upi-payment-requests">
                <img src="/assets/images/stokez.png" width="30" height="30" />{" "}
                View UPI Requests
              </NavLink>
            </li> */}
						{hasAccess(account, 0) && (
							<li>
								<NavLink to="/macid-approvals">
									<img src="/assets/images/security.png" width="30" height="30" /> MacID Approvals
								</NavLink>
							</li>
						)}

						{hasAccess(account, 1) && (
							<li>
								<NavLink to="/all-stokez">
									<img src="/assets/images/stokez.png" width="30" height="30" /> View Stokist
								</NavLink>
							</li>
						)}

						{hasAccess(account, 2) && (
							<li>
								<NavLink to="/all-master">
									<img src="/assets/images/agents.png" width="30" height="30" /> View Master
								</NavLink>
							</li>
						)}

						{hasAccess(account, 3) && (
							<li>
								<NavLink to="/all-agents">
									<img src="/assets/images/agents.png" width="30" height="30" /> View Agents
								</NavLink>
							</li>
						)}
						{hasAccess(account, 4) && (
							<li>
								<NavLink to="/all-users">
									<img src="/assets/images/agents.png" width="30" height="30" /> View Users
								</NavLink>
							</li>
						)}

						{hasAccess(account, 0) && (
							<li>
								<NavLink to="/all-players">
									<img src="/assets/images/players.png" width="30" height="30" /> View All Players
								</NavLink>
							</li>
						)}

						{hasAccess(account, 0) && (
							<li>
								<NavLink to="/transfer-points">
									<img src="/assets/images/transfer-points.png" width="30" height="30" /> Transfer Points
								</NavLink>
							</li>
						)}
						{/* <li>
              <NavLink to="/adjust-points">
                <img
                  src="/assets/images/adjust-points.png"
                  width="30"
                  height="30"
                />{" "}
                Adjust Points
              </NavLink>
            </li> */}
						{/* <li>
              <NavLink to="/change-password">
                <img
                  src="/assets/images/change-password.png"
                  width="30"
                  height="30"
                />{" "}
                Change Password
              </NavLink>
            </li> */}
						<li>
							<NavLink to="/turnover-report">
								<img src="/assets/images/turnover-report.png" width="30" height="30" /> Turnover Report
							</NavLink>
						</li>
						<li>
							<NavLink to="/bet-history">
								<img src="/assets/images/player-history.png" width="30" height="30" /> Bet History
							</NavLink>
						</li>
						{/* <li>
              <NavLink to="/transaction-report">
                <img
                  src="/assets/images/transaction-report.png"
                  width="30"
                  height="30"
                />{" "}
                Transaction Report
              </NavLink>
            </li> */}
						<li>
							<NavLink to="/result-history">
								<img src="/assets/images/result-history.png" width="30" height="30" /> Result History
							</NavLink>
						</li>
						{/* <li>
              <NavLink to="/player-security">
                <img src="/assets/images/security.png" width="30" height="30" />{" "}
                Security
              </NavLink>
            </li> */}
						{hasAccess(account, 1) && (
							<li>
								<NavLink to="/id-password-change">
									<img src="/assets/images/id-password-change.png" width="30" height="30" /> Password Change
								</NavLink>
							</li>
						)}
					</ul>
				</aside>
				{/* )} */}
				<main>
					<div className="container">
						<Outlet />
					</div>
				</main>
			</div>
		</>
	);
}

export default HeaderAndSidenav;
